export default "__VITE_ASSET__HFSV6kXJ__"